import { gql } from '@apollo/client'

export const GET_FIELDS = gql`
  query GET_FIELDS($parent: String!) {
    companyCustomFields(parent: $parent) {
      id
      name
      type
      required
      parent
    }
  }
`
export const DELETED_ITEMS = gql`
  query DELETED_ITEMS(
    $userId: ID
    $patient: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $searchTerm: String
    $rangeDate: [DateTime!]!
    $filters: Filter
  ) {
    deletedItems(
      userId: $userId
      patient: $patient
      orderBy: $orderBy
      skip: $skip
      take: $take
      searchTerm: $searchTerm
      rangeDate: $rangeDate
      filters: $filters
    ) {
      id
      title
      type
      model
      viewable
      restoredAt
      restoredBy {
        id
        name
      }
      createdBy {
        id
        name
      }
      patient {
        id
        fullName
      }
      createdAt
    }
  }
`
export const TOTAL_DELETED_ITEMS = gql`
  query TOTAL_DELETED_ITEMS($userId: ID, $patient: ID, $searchTerm: String, $rangeDate: [DateTime!]!, $filters: Filter) {
    totalDeletedItems(userId: $userId, patient: $patient, searchTerm: $searchTerm, rangeDate: $rangeDate, filters: $filters)
  }
`
export const TOTAL_BRANCHES = gql`
  query TOTAL_BRANCHES($searchTerm: String, $id: ID) {
    totalBranches(searchTerm: $searchTerm, company: $id)
  }
`
export const GET_BRANCHES = gql`
  query GET_BRANCHES($orderBy: String!, $skip: Int!, $take: Int!, $searchTerm: String, $id: ID) {
    branches(orderBy: $orderBy, skip: $skip, take: $take, searchTerm: $searchTerm, company: $id) {
      id
      name
      opens
      closes
      openDays
      viewClosedTimes
      rooms
      disabled
      address
      location
      phones
      specialities
      appointmentTypes
      firstDay
      users {
        id
        name
        isDoctor
      }
      branchTreasuries {
        type
        defaultTreasury {
          id
          name
        }
        availableTreasuries {
          id
          name
        }
        allowPending
      }
      diagnosticFee
      defaultPriceList {
        id
        name
      }
      availablePriceLists {
        id
        name
      }
      updatedAt
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      company {
        id
        disabled
        companyName
      }
    }
  }
`
export const BRANCH_DETAILS = gql`
  query BRANCH_DETAILS($branch: ID!, $token: String) {
    branchDetails(branch: $branch, token: $token) {
      id
      name
      opens
      closes
      openDays
      viewClosedTimes
      rooms
      disabled
      address
      location
      phones
      specialities
      appointmentTypes
      firstDay
      breaks
      holidays
      nphiesCode
      users {
        id
        name
        color
        order
        isDoctor
        disabled
        calendarSettings
        assistants {
          id
          name
          disabled
        }
      }
      diagnosticFee
      invoiceUsers {
        id
        name
      }
      quotationUsers {
        id
        name
      }
      formUsers {
        id
        name
      }
      prescriptionUsers {
        id
        name
      }
      labOrderUsers {
        id
        name
      }
      appointmentUsers {
        id
        name
      }
      defaultPriceList {
        id
        name
      }
      availablePriceLists {
        id
        name
      }
      branchTreasuries {
        type
        defaultTreasury {
          id
          name
        }
        availableTreasuries {
          id
          name
        }
        allowPending
      }
      prescriptionJsonForm
      invoiceJsonForm
      chartJsonForm
      expensesJsonForm
      labOrderJsonForm
      freeFormJsonForm
      updatedAt
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const TOTAL_GROUPS = gql`
  query TOTAL_GROUPS($searchTerm: String, $filters: Filter) {
    totalGroups(searchTerm: $searchTerm, filters: $filters)
  }
`
export const GET_GROUPS = gql`
  query GET_GROUPS($orderBy: String!, $skip: Int!, $take: Int!, $searchTerm: String, $filters: Filter) {
    groups(orderBy: $orderBy, skip: $skip, take: $take, searchTerm: $searchTerm, filters: $filters) {
      id
      name
      color
      description
      permissions
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      _count {
        users
      }
    }
  }
`
export const GROUP_DETAILS = gql`
  query GROUP_DETAILS($group: ID!) {
    groupDetails(group: $group) {
      id
      name
      color
      description
      permissions
      allowedIps
      users {
        id
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const TOTAL_MESSAGES = gql`
  query TOTAL_MESSAGES($searchTerm: String, $filters: Filter) {
    totalMessages(searchTerm: $searchTerm, filters: $filters)
  }
`
export const GET_MESSAGES = gql`
  query GET_MESSAGES($orderBy: String!, $skip: Int!, $take: Int!, $searchTerm: String, $filters: Filter) {
    messages(orderBy: $orderBy, skip: $skip, take: $take, searchTerm: $searchTerm, filters: $filters) {
      id
      name
      details
      active
      when
      at
      day
      before
      createdAt
      updatedAt
      types
      whatsAppTemplate
      appointmentTypes
      appointmentType
      template {
        id
        status
        whatsAppID
      }
      branch {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const TOTAL_LABS = gql`
  query TOTAL_LABS($searchTerm: String) {
    totalLabs(searchTerm: $searchTerm)
  }
`
export const GET_LABS = gql`
  query GET_LABS($orderBy: String!, $skip: Int!, $take: Int!, $searchTerm: String) {
    labs(orderBy: $orderBy, skip: $skip, take: $take, searchTerm: $searchTerm) {
      id
      name
      number
      email
      details
      createdAt
      updatedAt
      disabled
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const TOTAL_LAB_ITEMS = gql`
  query TOTAL_LABS($lab: ID, $searchTerm: String) {
    totalLabItems(lab: $lab, searchTerm: $searchTerm)
  }
`
export const GET_LAB_ITEMS = gql`
  query GET_LABS($lab: ID, $orderBy: String!, $skip: Int!, $take: Int!, $searchTerm: String) {
    labItems(lab: $lab, orderBy: $orderBy, skip: $skip, take: $take, searchTerm: $searchTerm) {
      id
      name
      price
      details
      images
      createdAt
      updatedAt
      lab {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const GET_LABS_ORDERS = gql`
  query GET_LABS_ORDERS(
    $branchId: ID
    $userId: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $filters: Filter
    $lab: ID
    $labItem: ID
    $patient: ID
    $assignedToId: ID
    $operation: ID
    $operationStep: ID
    $searchTerm: String
    $appointment: ID
  ) {
    labOrders(
      branchId: $branchId
      userId: $userId
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      filters: $filters
      lab: $lab
      labItem: $labItem
      patient: $patient
      assignedToId: $assignedToId
      operation: $operation
      operationStep: $operationStep
      searchTerm: $searchTerm
      appointment: $appointment
    ) {
      id
      name
      price
      items
      details
      due
      paid
      received
      images
      shade
      tooth
      child
      delivered
      lab {
        id
        number
        name
      }
      labItem {
        id
        name
        images
        price
      }
      expense {
        id
        name
        paid
        amount
        branchId
      }
      branch {
        id
        name
        address
        phones
      }
      patient {
        id
        firstName
        lastName
        patientId
        referenceId
        title
      }
      appointment {
        id
        start
        status
      }
      user {
        id
        name
      }
      users {
        id
        name
      }
      receivedAt
      paidAt
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const LAB_ORDER_DETAILS = gql`
  query LAB_ORDER_DETAILS($labOrder: ID!, $token: String) {
    labOrderDetails(labOrder: $labOrder, token: $token) {
      id
      name
      price
      items
      details
      due
      paid
      received
      images
      shade
      tooth
      child
      delivered
      lab {
        id
        name
        number
      }
      expense {
        id
        name
        paid
        amount
        branchId
      }
      labItem {
        id
        name
        images
        price
      }
      user {
        id
        name
      }
      users {
        id
        name
      }
      branch {
        id
        name
        address
        phones
      }
      patient {
        id
        firstName
        lastName
        patientId
        referenceId
        title
      }
      appointment {
        id
        start
        status
        room
      }
      receivedAt
      paidAt
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const TOTAL_LABS_ORDERS = gql`
  query TOTAL_LABS_ORDERS(
    $branchId: ID
    $userId: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $lab: ID
    $labItem: ID
    $patient: ID
    $assignedToId: ID
    $operation: ID
    $operationStep: ID
    $searchTerm: String
    $appointment: ID
  ) {
    totalLabOrders(
      branchId: $branchId
      userId: $userId
      rangeDate: $rangeDate
      filters: $filters
      lab: $lab
      labItem: $labItem
      patient: $patient
      assignedToId: $assignedToId
      operation: $operation
      operationStep: $operationStep
      searchTerm: $searchTerm
      appointment: $appointment
    )
  }
`
export const LABS_ORDERS_INFO = gql`
  query LABS_ORDERS_INFO(
    $branchId: ID
    $userId: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $lab: ID
    $labItem: ID
    $patient: ID
    $assignedToId: ID
    $operation: ID
    $searchTerm: String
    $appointment: ID
  ) {
    labOrdersInfo(
      branchId: $branchId
      userId: $userId
      rangeDate: $rangeDate
      filters: $filters
      lab: $lab
      labItem: $labItem
      patient: $patient
      assignedToId: $assignedToId
      operation: $operation
      searchTerm: $searchTerm
      appointment: $appointment
    ) {
      received
      delivered
      _count
    }
  }
`
export const LAB_DETAILS = gql`
  query LAB_DETAILS($lab: ID!) {
    labDetails(lab: $lab) {
      id
      name
      number
      email
      details
      createdAt
      updatedAt
      disabled
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const LAB_ITEM_DETAILS = gql`
  query LAB_ITEM_DETAILS($labItem: ID!) {
    labItemDetails(labItem: $labItem) {
      id
      name
      price
      details
      images
      createdAt
      updatedAt
      lab {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const TOTAL_SUPPLIERS = gql`
  query TOTAL_SUPPLIERS($searchTerm: String) {
    totalSuppliers(searchTerm: $searchTerm)
  }
`
export const GET_SUPPLIERS = gql`
  query GET_SUPPLIERS($orderBy: String!, $skip: Int!, $take: Int!, $searchTerm: String) {
    suppliers(orderBy: $orderBy, skip: $skip, take: $take, searchTerm: $searchTerm) {
      id
      name
      number
      email
      details
      createdAt
      updatedAt
      disabled
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const SUPPLIER_DETAILS = gql`
  query SUPPLIER_DETAILS($supplier: ID!) {
    supplierDetails(supplier: $supplier) {
      id
      name
      number
      email
      details
      createdAt
      updatedAt
      disabled
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const MESSAGE_DETAILS = gql`
  query MESSAGE_DETAILS($message: ID!) {
    messageDetails(message: $message) {
      id
      name
      details
      active
      when
      at
      day
      before
      types
      whatsAppTemplate
      appointmentTypes
      appointmentType
      template {
        id
        status
        whatsAppID
      }
      createdAt
      updatedAt
      branch {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const TOTAL_USERS = gql`
  query TOTAL_USERS($searchTerm: String, $id: ID, $group: ID, $filters: Filter) {
    totalUsers(searchTerm: $searchTerm, company: $id, group: $group, filters: $filters)
  }
`
export const GET_USERS = gql`
  query GET_USERS(
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $searchTerm: String
    $rangeDate: [DateTime!]!
    $id: ID
    $group: ID
    $filters: Filter
  ) {
    users(
      orderBy: $orderBy
      skip: $skip
      take: $take
      searchTerm: $searchTerm
      rangeDate: $rangeDate
      company: $id
      group: $group
      filters: $filters
    ) {
      id
      email
      name
      order
      username
      company {
        id
        companyName
      }
      group {
        id
        name
        color
      }
      automatic
      paymentType
      automaticExpenses
      expensesFrom
      validated
      disabled
      twoFactorAuth
      dentalNotation
      doctorPercentage
      diagnosticFee
      diagnosticFeePercent
      labOrderPercent
      phoneNumber
      phoneNumber2
      hasValidNumber
      address
      isDoctor
      isOwner
      salary
      job
      chart
      maxDiscount
      maxDiscountAnd
      maxDiscountPercent
      sessionTimeoutMinutes
      rememberSessionTimeoutMinutes
      medicalNumber
      images
      twoFactorAuth
      showAttendance
      requireScreenshot
      color
      branches {
        id
        name
        nphiesCode
      }
      customFields {
        id
        value
        field {
          id
        }
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const COMPANY_ACTIVE_MESSAGES = gql`
  query COMPANY_ACTIVE_MESSAGES($branch: ID) {
    companyActiveMessages(branch: $branch) {
      NOTE_TIME
      NOTE_CREATED
      PATIENT_CREATED
      APPOINTMENT_CREATED
      APPOINTMENT_TIME
      APPOINTMENT_CONFIRMED
      APPOINTMENT_CHECKEDIN
      APPOINTMENT_COMPLETED
      APPOINTMENT_CANCELED
      APPOINTMENT_NOSHOW
      APPOINTMENT_DELAYED
      APPOINTMENT_WAITING
      APPOINTMENT_INPROGRESS
      PRESCRIPTION_CREATED
      FREE_FORM_CREATED
      INVOICE_CREATED
      QUOTATION_CREATED
      PAYMENT_CREATED
      LAB_ORDER_CREATED
      SUPPLIER_ORDER_CREATED
      PATIENT_ENCOUNTER_CREATED
    }
  }
`
export const USER_DETAILS = gql`
  query USER_DETAILS($user: ID!) {
    userDetails(user: $user) {
      id
      email
      name
      username
      profiles {
        id
        locale
        title
        profession
        bio
      }
      group {
        id
        name
        color
        permissions
      }
      sessionTimeoutMinutes
      rememberSessionTimeoutMinutes
      automatic
      automaticExpenses
      expensesFrom
      validated
      order
      dentalNotation
      doctorPercentage
      diagnosticFee
      diagnosticFeePercent
      labOrderPercent
      disabled
      phoneNumber
      phoneNumber2
      hasValidNumber
      address
      isDoctor
      assistants {
        id
        name
      }
      isOwner
      twoFactorAuth
      salary
      job
      specialityCode
      chart
      maxDiscount
      maxDiscountAnd
      maxDiscountPercent
      medicalNumber
      images
      paymentType
      showAttendance
      requireScreenshot
      color
      userSystemChat {
        id
        internalNotification
        supportNotification
      }
      calendarSettings
      pendingMerge
      mergeToId
      branches {
        id
        name
        rooms
        nphiesCode
      }
      customFields {
        id
        value
        field {
          id
        }
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const TOTAL_REFERRALS = gql`
  query TOTAL_REFERRALS($id: ID, $rangeDate: [DateTime!]!) {
    totalReferrals(id: $id, rangeDate: $rangeDate)
  }
`
export const GET_REFERRALS = gql`
  query GET_REFERRALS($id: ID, $orderBy: String!, $skip: Int!, $take: Int!, $rangeDate: [DateTime!]!) {
    referrals(id: $id, orderBy: $orderBy, skip: $skip, take: $take, rangeDate: $rangeDate) {
      id
      firstName
      lastName
      patientId
      referenceId
      phoneNumber
      hasValidNumber
      phoneNumber2
      gender
      marital
      email
      insuranceCompany {
        id
        name
      }
      tax
      insuranceNumber
      insuranceGroup
      insuranceCRT
      insured
      insuranceLimit
      insuranceUnlimited
      approvalRequired
      insurancePercentage
      insuranceEndDate
      insuranceStartMonth
      disabled
      pending
      details
      phoneNumber
      firstNameE
      lastNameE
      phoneNumberE
      phoneNumber2E
      nationality
      addressE
      relationE
      country
      address
      longitude
      latitude
      title
      balance
      totalInsurance
      totalPaid
      totalRemaining
      birthDate
      birthDay
      job
      patientTags {
        id
        name
        color
        hasNextTags
      }
      referralSource {
        id
        name
        color
      }
      referralSubSource {
        id
        name
        color
      }
      images
      hasPendingMedical
      doctor {
        id
        name
      }
      branch {
        id
        name
      }
      priceList {
        id
        name
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      referralUser {
        id
        name
      }
      referralPatient {
        id
        firstName
        lastName
      }
    }
  }
`
export const TOTAL_TICKETS = gql`
  query TOTAL_TICKETS($rangeDate: [DateTime!]!, $searchTerm: String) {
    totalTickets(rangeDate: $rangeDate, searchTerm: $searchTerm)
  }
`
export const GET_TICKETS = gql`
  query GET_TICKETS($orderBy: String!, $skip: Int!, $take: Int!, $rangeDate: [DateTime!]!, $searchTerm: String) {
    tickets(orderBy: $orderBy, skip: $skip, take: $take, rangeDate: $rangeDate, searchTerm: $searchTerm) {
      id
      subject
      closed
      createdAt
    }
  }
`
export const TICKET_DETAILS = gql`
  query TICKET_DETAILS($ticket: ID!) {
    ticketDetails(ticket: $ticket) {
      id
      subject
      closed
      createdAt
    }
  }
`
export const TICKET_MESSAGES = gql`
  query TICKET_MESSAGES($ticket: ID!, $skip: Int!, $take: Int!) {
    ticketMessages(ticket: $ticket, skip: $skip, take: $take) {
      id
      content
      sender {
        id
        name
      }
      createdAt
    }
  }
`
export const TOTAL_TICKET_MESSAGES = gql`
  query TOTAL_TICKET_MESSAGES($ticket: ID!) {
    totalTicketMessages(ticket: $ticket)
  }
`
export const TOTAL_MONTHLY_EXPENSES = gql`
  query TOTAL_MONTHLY_EXPENSES($searchTerm: String, $filters: Filter) {
    totalMonthlyExpenses(searchTerm: $searchTerm, filters: $filters)
  }
`
export const GET_MONTHLY_EXPENSES = gql`
  query GET_MONTHLY_EXPENSES($orderBy: String!, $skip: Int!, $take: Int!, $searchTerm: String, $filters: Filter) {
    monthlyExpenses(orderBy: $orderBy, skip: $skip, take: $take, searchTerm: $searchTerm, filters: $filters) {
      id
      name
      type
      details
      amount
      other
      automatic
      active
      paymentType
      branch {
        id
        name
      }
      user {
        id
        name
        group {
          id
          color
        }
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const MONTHLY_EXPENSE_DETAILS = gql`
  query MONTHLY_EXPENSE_DETAILS($monthlyExpense: ID!) {
    monthlyExpenseDetails(monthlyExpense: $monthlyExpense) {
      id
      name
      type
      details
      amount
      other
      automatic
      active
      paymentType
      branch {
        id
        name
      }
      user {
        id
        name
        group {
          id
          color
        }
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const TOTAL_EXPENSES = gql`
  query TOTAL_EXPENSES(
    $branchId: ID
    $assignedToId: ID
    $userId: ID
    $supplier: ID
    $lab: ID
    $labItem: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $searchTerm: String
  ) {
    totalExpenses(
      branchId: $branchId
      assignedToId: $assignedToId
      userId: $userId
      supplier: $supplier
      lab: $lab
      labItem: $labItem
      rangeDate: $rangeDate
      filters: $filters
      searchTerm: $searchTerm
    )
  }
`
export const GET_EXPENSES = gql`
  query GET_EXPENSES(
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $branchId: ID
    $assignedToId: ID
    $userId: ID
    $supplier: ID
    $lab: ID
    $labItem: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $searchTerm: String
  ) {
    expenses(
      orderBy: $orderBy
      skip: $skip
      take: $take
      branchId: $branchId
      assignedToId: $assignedToId
      userId: $userId
      supplier: $supplier
      lab: $lab
      labItem: $labItem
      rangeDate: $rangeDate
      filters: $filters
      searchTerm: $searchTerm
    ) {
      id
      name
      type
      mainType
      details
      amount
      other
      date
      paid
      items
      automatic
      isInstallments
      installment
      every
      interval
      confirmed
      isDebt
      salaryAdjustment {
        id
      }
      branch {
        id
        name
      }
      supplier {
        id
        name
        number
      }
      lab {
        id
        name
        number
      }
      labOrder {
        id
        received
        delivered
        patient {
          id
          firstName
          lastName
        }
      }
      user {
        id
        name
        group {
          id
          color
        }
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
      _count {
        payments
      }
    }
  }
`
export const EXPENSE_DETAILS = gql`
  query EXPENSE_DETAILS($expense: ID!, $token: String) {
    expenseDetails(expense: $expense, token: $token) {
      id
      name
      type
      mainType
      details
      amount
      other
      date
      paid
      items
      automatic
      isInstallments
      installment
      every
      interval
      confirmed
      isDebt
      salaryAdjustment {
        id
      }
      purchaseOrderItems {
        id
        name
        total
        quantity
      }
      payments {
        id
        type
        amount
        other
        refunded
      }
      branch {
        id
        name
        company {
          id
          expenseTypes
        }
      }
      supplier {
        id
        name
        number
      }
      lab {
        id
        name
        number
      }
      labOrder {
        id
        received
        delivered
        patient {
          id
          firstName
          lastName
        }
      }
      inventoryOrder {
        id
        transactions {
          id
          total
          amount
          inventorySubItem {
            id
            name
          }
        }
      }
      user {
        id
        name
        group {
          id
          color
        }
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`

export const EXPENSE_DETAILS_FOR_QR = gql`
  query EXPENSE_DETAILS_FOR_QR($expense: ID!) {
    expenseDetailsForQR(expense: $expense) {
      id
      name
      type
      details
      amount
      other
      date
      paid
      items
      confirmed
      purchaseOrderItems {
        id
        name
        total
        quantity
      }
      inventoryOrder {
        id
        transactions {
          id
          total
          amount
          inventorySubItem {
            id
            name
          }
        }
      }
      branch {
        id
        name
        address
        phones
        expensesJsonForm
        company {
          id
          companyName
          currency
          companyLogo
          expenseTypes
          defaultLanguage
        }
      }
      supplier {
        id
        name
      }
      lab {
        id
        name
      }
      user {
        id
        name
      }
    }
  }
`

export const TOTAL_INCOMES = gql`
  query TOTAL_INCOMES(
    $branchId: ID
    $userId: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $assignedToId: ID
    $searchTerm: String
  ) {
    totalIncomes(
      branchId: $branchId
      userId: $userId
      rangeDate: $rangeDate
      filters: $filters
      assignedToId: $assignedToId
      searchTerm: $searchTerm
    )
  }
`
export const GET_INCOMES = gql`
  query GET_INCOMES(
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $branchId: ID
    $userId: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $assignedToId: ID
    $searchTerm: String
  ) {
    incomes(
      orderBy: $orderBy
      skip: $skip
      take: $take
      branchId: $branchId
      userId: $userId
      rangeDate: $rangeDate
      filters: $filters
      assignedToId: $assignedToId
      searchTerm: $searchTerm
    ) {
      id
      name
      type
      details
      amount
      other
      date
      paymentType
      user {
        id
        name
        group {
          id
          color
        }
      }
      patient {
        id
        firstName
        lastName
      }
      expense {
        id
        name
      }
      branch {
        id
        name
      }
      transaction {
        id
        treasury {
          id
          publicName
        }
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const INCOME_DETAILS = gql`
  query INCOME_DETAILS($income: ID!, $token: String) {
    incomeDetails(income: $income, token: $token) {
      id
      name
      type
      details
      amount
      date
      other
      paymentType
      user {
        id
        name
        group {
          id
          color
        }
      }
      patient {
        id
        firstName
        lastName
      }
      expense {
        id
        name
      }
      branch {
        id
        name
      }
      transaction {
        id
        treasury {
          id
          publicName
        }
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const DASHBOARD_HOME_INFO = gql`
  query DASHBOARD_HOME_INFO(
    $doctor: ID
    $branchId: ID
    $userId: ID
    $id: ID
    $rangeDate: [DateTime!]!
    $assignedToId: ID
    $forPayments: Boolean
  ) {
    dashboardHomeInfo(
      doctor: $doctor
      branchId: $branchId
      userId: $userId
      patient: $id
      rangeDate: $rangeDate
      assignedToId: $assignedToId
      forPayments: $forPayments
    ) {
      appointments {
        status
        _count
      }
      invoices {
        total
        pendingPayment
        paid
      }
      payments {
        type
        claimed
        _sum
      }
      lastAppointments {
        status
        _count
      }
      lastInvoices {
        total
        pendingPayment
        paid
      }
      lastPayments {
        type
        claimed
        _sum
      }
      patients
      lastPatients
    }
  }
`
export const GET_NOTIFICATIONS = gql`
  query GET_NOTIFICATIONS(
    $branch: ID!
    $rangeDate: [DateTime!]!
    $alertSettings: [String!]!
    $alertBeforeInventory: Int
    $alertBeforeMaster: Int
    $alertBeforeOperations: Int
  ) {
    getNotifications(
      branch: $branch
      rangeDate: $rangeDate
      alertSettings: $alertSettings
      alertBeforeInventory: $alertBeforeInventory
      alertBeforeMaster: $alertBeforeMaster
      alertBeforeOperations: $alertBeforeOperations
    ) {
      id
      inventoryItem
      location
      inventoryOrder
      invoices
      reminders
      patients
      calendar
      orders
      operations
      notes
      prescriptions
      transactions
      patientForms
      taskInstances
      callRequests
    }
  }
`

export const DASHBOARD_APPOINTMENTS_INFO = gql`
  query DASHBOARD_APPOINTMENTS_INFO(
    $doctor: ID
    $branchId: ID
    $userId: ID
    $id: ID
    $searchTerm: String
    $rangeDate: [DateTime!]!
    $filters: Filter
    $forDashboard: Boolean
    $currentUserTime: Boolean
  ) {
    dashboardAppointmentsInfo(
      doctor: $doctor
      branchId: $branchId
      userId: $userId
      patient: $id
      searchTerm: $searchTerm
      rangeDate: $rangeDate
      filters: $filters
      forDashboard: $forDashboard
      currentUserTime: $currentUserTime
    ) {
      appointments {
        status
        _count
      }
      lastAppointments {
        status
        _count
      }
      patients
      lastPatients
    }
  }
`
export const DASHBOARD_INVOICES_INFO = gql`
  query DASHBOARD_INVOICES_INFO(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $id: ID
    $rangeDate: [DateTime!]!
    $pendingPayment: Boolean
    $showUpdatedInvoices: Boolean
    $filters: Filter
  ) {
    dashboardInvoicesInfo(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $id
      rangeDate: $rangeDate
      pendingPayment: $pendingPayment
      showUpdatedInvoices: $showUpdatedInvoices
      filters: $filters
    ) {
      invoices {
        total
        pendingPayment
        paid
      }
      lastInvoices {
        total
        pendingPayment
        paid
      }
    }
  }
`
export const DASHBOARD_PAYMENTS_INFO = gql`
  query DASHBOARD_PAYMENTS_INFO(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $id: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $insuranceCompanies: [ID]
  ) {
    dashboardPaymentsInfo(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $id
      rangeDate: $rangeDate
      filters: $filters
      insuranceCompanies: $insuranceCompanies
    ) {
      payments {
        type
        claimed
        _sum
      }
      lastPayments {
        type
        claimed
        _sum
      }
    }
  }
`

export const EXPENSE_PAYMENTS = gql`
  query EXPENSE_PAYMENTS(
    $expense: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $filters: Filter
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $supplier: ID
    $searchTerm: String
    $lab: ID
    $labItem: ID
  ) {
    expensePayments(
      expense: $expense
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      filters: $filters
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      supplier: $supplier
      searchTerm: $searchTerm
      lab: $lab
      labItem: $labItem
    ) {
      id
      type
      amount
      other
      details
      images
      refunded
      expenseType
      expense {
        id
        name
        paid
        amount
        type
        date
        other
        branch {
          id
          name
        }
        createdBy {
          id
          name
        }
      }
      transaction {
        id
        treasury {
          id
          publicName
        }
      }
      refundedAt
      refundedBy {
        id
        name
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedAt
      updatedBy {
        id
        name
      }
    }
  }
`
export const TOTAL_EXPENSE_PAYMENTS = gql`
  query TOTAL_EXPENSE_PAYMENTS(
    $expense: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $supplier: ID
    $searchTerm: String
    $lab: ID
    $labItem: ID
  ) {
    totalExpensePayments(
      expense: $expense
      rangeDate: $rangeDate
      filters: $filters
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      supplier: $supplier
      searchTerm: $searchTerm
      lab: $lab
      labItem: $labItem
    )
  }
`
export const EXPENSE_PAYMENT_DETAILS = gql`
  query EXPENSE_PAYMENT_DETAILS($payment: ID!) {
    expensePaymentDetails(payment: $payment) {
      id
      type
      amount
      other
      details
      images
      refunded
      expenseType
      expense {
        id
        name
        paid
        amount
        type
        date
        other
        branch {
          id
          name
        }
        createdBy {
          id
          name
        }
      }
      transaction {
        id
        treasury {
          id
          publicName
        }
      }
      refundedAt
      refundedBy {
        id
        name
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedAt
      updatedBy {
        id
        name
      }
    }
  }
`
export const EXPENSE_PAYMENTS_INFO = gql`
  query EXPENSE_PAYMENTS_INFO(
    $expense: ID
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $rangeDate: [DateTime!]!
    $supplier: ID
    $searchTerm: String
    $filters: Filter
    $lab: ID
    $labItem: ID
  ) {
    expensePaymentsInfo(
      expense: $expense
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      rangeDate: $rangeDate
      supplier: $supplier
      searchTerm: $searchTerm
      filters: $filters
      lab: $lab
      labItem: $labItem
    ) {
      type
      refunded
      _sum
    }
  }
`

export const TOTAL_TREASURIES = gql`
  query TOTAL_TREASURIES(
    $userId: ID
    $branchId: ID
    $assignedToId: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $searchTerm: String
  ) {
    totalTreasuries(
      userId: $userId
      branchId: $branchId
      assignedToId: $assignedToId
      rangeDate: $rangeDate
      filters: $filters
      searchTerm: $searchTerm
    )
  }
`
export const TREASURIES = gql`
  query TREASURIES(
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $userId: ID
    $branchId: ID
    $assignedToId: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $searchTerm: String
  ) {
    treasuries(
      orderBy: $orderBy
      skip: $skip
      take: $take
      userId: $userId
      branchId: $branchId
      assignedToId: $assignedToId
      rangeDate: $rangeDate
      filters: $filters
      searchTerm: $searchTerm
    ) {
      id
      name
      number
      email
      details
      publicName
      type
      initialBalance
      balance
      leftOver
      automatic
      transferAt
      transferPercent
      deductFromCredit
      transferTo {
        id
        name
      }
      users {
        id
        name
        group {
          id
          name
          color
        }
      }
      branch {
        id
        name
      }
      user {
        id
        name
      }
      createdAt
      updatedAt
      tz
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const TREASURY_DETAILS = gql`
  query TREASURY_DETAILS($treasury: ID!) {
    treasuryDetails(treasury: $treasury) {
      id
      name
      number
      email
      details
      publicName
      type
      initialBalance
      balance
      leftOver
      automatic
      transferAt
      transferPercent
      deductFromCredit
      transferTo {
        id
        name
      }
      users {
        id
        name
        group {
          id
          name
          color
        }
      }
      user {
        id
        name
      }
      branch {
        id
        name
      }
      createdAt
      updatedAt
      tz
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`

export const TOTAL_TRANSACTIONS = gql`
  query TOTAL_TRANSACTIONS(
    $userId: ID
    $branchId: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $assignedToId: ID
    $treasury: ID
    $searchTerm: String
  ) {
    totalTransactions(
      userId: $userId
      branchId: $branchId
      rangeDate: $rangeDate
      filters: $filters
      assignedToId: $assignedToId
      treasury: $treasury
      searchTerm: $searchTerm
    )
  }
`
export const TRANSACTIONS = gql`
  query TRANSACTIONS(
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $userId: ID
    $branchId: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $assignedToId: ID
    $treasury: ID
    $searchTerm: String
  ) {
    transactions(
      orderBy: $orderBy
      skip: $skip
      take: $take
      userId: $userId
      branchId: $branchId
      rangeDate: $rangeDate
      filters: $filters
      assignedToId: $assignedToId
      treasury: $treasury
      searchTerm: $searchTerm
    ) {
      id
      type
      amount
      other
      details
      images
      transactionId
      referenceId
      incoming
      pending
      confirmed
      deducted
      initialBalance
      balance
      room
      receivedAt
      updatedAt
      createdAt
      deleted
      deletedReferenceId
      treasury {
        id
        publicName
      }
      income {
        id
        name
        type
      }
      billingPayment {
        id
        expense {
          id
          name
          type
        }
      }
      payment {
        id
        refunded
        invoice {
          id
          patient {
            id
            firstName
            lastName
          }
        }
      }
      receivedTreasury {
        id
        publicName
      }
      branch {
        id
        name
      }
      user {
        id
        name
      }
      receivedBy {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const TRANSACTION_DETAILS = gql`
  query TRANSACTION_DETAILS($transaction: ID!) {
    transactionDetails(transaction: $transaction) {
      id
      type
      amount
      other
      details
      images
      transactionId
      referenceId
      incoming
      pending
      confirmed
      deducted
      initialBalance
      balance
      room
      receivedAt
      updatedAt
      createdAt
      deleted
      deletedReferenceId
      treasury {
        id
        publicName
      }
      income {
        id
        name
        type
      }
      billingPayment {
        id
        expense {
          id
          name
          type
        }
      }
      payment {
        id
        refunded
        invoice {
          id
          patient {
            id
            firstName
            lastName
          }
        }
      }
      receivedTreasury {
        id
        publicName
      }
      branch {
        id
        name
      }
      user {
        id
        name
      }
      receivedBy {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const TREASURIES_INFO = gql`
  query TREASURIES_INFO(
    $userId: ID
    $branchId: ID
    $assignedToId: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $searchTerm: String
  ) {
    treasuriesInfo(
      userId: $userId
      branchId: $branchId
      assignedToId: $assignedToId
      rangeDate: $rangeDate
      filters: $filters
      searchTerm: $searchTerm
    ) {
      type
      balance
    }
  }
`
export const TRANSACTIONS_INFO = gql`
  query TRANSACTIONS_INFO(
    $userId: ID
    $branchId: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $assignedToId: ID
    $treasury: ID
    $searchTerm: String
  ) {
    transactionsInfo(
      userId: $userId
      branchId: $branchId
      rangeDate: $rangeDate
      filters: $filters
      assignedToId: $assignedToId
      treasury: $treasury
      searchTerm: $searchTerm
    ) {
      incoming
      amount
      deducted
    }
  }
`
export const GET_ATTENDANCE_LOCATIONS = gql`
  query GET_ATTENDANCE_LOCATIONS {
    getAttendanceLocations {
      id
      attendanceLocations
      acceptedRange
    }
  }
`

export const TOTAL_FREE_FORMS = gql`
  query TOTAL_FREE_FORMS($searchTerm: String, $rangeDate: [DateTime!]!, $filters: Filter) {
    totalFreeForms(searchTerm: $searchTerm, rangeDate: $rangeDate, filters: $filters)
  }
`
export const FREE_FORMS = gql`
  query FREE_FORMS($orderBy: String!, $skip: Int!, $take: Int!, $searchTerm: String, $rangeDate: [DateTime!]!, $filters: Filter) {
    freeForms(orderBy: $orderBy, skip: $skip, take: $take, rangeDate: $rangeDate, searchTerm: $searchTerm, filters: $filters) {
      id
      name
      content
      jsonForm
      expiresIn
      updatedAt
      createdAt
      signRequired
      showOnline
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const FREE_FORM_DETAILS = gql`
  query FREE_FORM_DETAILS($form: ID!) {
    freeFormDetails(form: $form) {
      id
      name
      content
      jsonForm
      expiresIn
      updatedAt
      createdAt
      signRequired
      showOnline
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`

export const OPERATION_STEPS_INFO = gql`
  query OPERATION_STEPS_INFO(
    $branchId: ID
    $userId: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $doctor: ID
    $patient: ID
    $insuranceCompanies: [ID]
    $insurancePolicy: ID
    $appointment: ID
    $searchTerm: String
    $priceList: ID
    $operation: ID
    $chart: ChartTypes
    $procedure: ID
    $procedureGroup: ID
    $forAppointmentUpdated: Boolean
  ) {
    operationStepsInfo(
      branchId: $branchId
      userId: $userId
      rangeDate: $rangeDate
      filters: $filters
      doctor: $doctor
      patient: $patient
      insuranceCompanies: $insuranceCompanies
      insurancePolicy: $insurancePolicy
      appointment: $appointment
      searchTerm: $searchTerm
      priceList: $priceList
      operation: $operation
      chart: $chart
      procedure: $procedure
      procedureGroup: $procedureGroup
      forAppointmentUpdated: $forAppointmentUpdated
    ) {
      paid
      total
      tax
      discount
      forLab
      forOperator
      package
    }
  }
`
